module.exports = __webpack_public_path__ + "media/images/sp/stores/asakusa/asakusa_concept_03-a24d8e22b86453ec692600d9bef62759.jpg";